// Pass as the `onUpdate` of a framer-motion component that animates opacity.
// With any onUpdate, framer-motion no longer hands the animation to the
// browser (WAAPI, see supportsBrowserAnimation in motion-dom): those browser
// animations show their starting value again for one frame when they finish,
// which made the booking steps and their card images blink as they appeared
// and as they left. Driven from the main thread there is no such frame.
export const keepAnimationOnMainThread = () => {};
